function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import { RouteParams, RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import CustomerLocaleKeys from '../../../../locales/keys';
// import {
//     OrderHistoryTab,
// } from '@invision/customercare2/src/customer/orderHistory';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { ORDER_HISTORY_LIST_STATE_NAME } from '../order.history.config';
import { GROUP_ORDER_HISTORY_LIST_STATE_NAME } from './order.history.list.wrapper.config';
import { GroupOrderFeatureVisibilitySelector } from '../../../../reducers/selectors/order.history.selectors';
var OrderHistoryListWrapperController = /*#__PURE__*/function () {
  function OrderHistoryListWrapperController($ngRedux, $timeout, $state, $location) {
    _classCallCheck(this, OrderHistoryListWrapperController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      $state: $state,
      $location: $location,
      CustomerLocaleKeys: CustomerLocaleKeys,
      onTabSelected: this.onTabSelected.bind(this)
      // OrderHistoryTab
    });
  }
  return _createClass(OrderHistoryListWrapperController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        stateGo: stateGo
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          isDbss: IsDbss(store),
          isFeatureToggleCodesLoaded: MetadataCodeLoadedSelector(CODES.FeatureToggleConfig, store),
          isGroupOrderEnabled: GroupOrderFeatureVisibilitySelector(store),
          routeParams: RouteParams(store),
          routeState: RouteCurrentStateSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isFeatureToggleCodesLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.FeatureToggleConfig);
      }
      this.resetTabs(this.state.routeState.url);
    }
  }, {
    key: "resetTabs",
    value: function resetTabs(currentTab) {
      this.tabs = [{
        name: i18n.translate(CustomerLocaleKeys.ORDER_HISTORY.ORDERS),
        state: ORDER_HISTORY_LIST_STATE_NAME,
        active: true,
        id: 'orders'
      }, {
        name: i18n.translate(CustomerLocaleKeys.ORDER_HISTORY.GROUP_ORDERS),
        state: GROUP_ORDER_HISTORY_LIST_STATE_NAME,
        active: false,
        id: 'group-orders'
      }];
    }
  }, {
    key: "onTabSelected",
    value: function onTabSelected(selected) {
      this.resetTabs(selected.id);
      this.actions.stateGo(selected.state, _objectSpread({}, this.state.routeParams));
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: OrderHistoryListWrapperController,
  template: require('./order.history.list.wrapper.template.html')
};